import { useMemo } from 'react';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

function parseInternalDomains(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(',')
    .map(d => d.trim().toLowerCase())
    .filter(Boolean);
}

function extractDomain(email: string): string {
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return '';
  return email.slice(atIndex + 1).toLowerCase();
}

export function useInternalDomainCheck(email: string): boolean {
  const configApi = useApi(configApiRef);

  const internalDomains = useMemo(() => {
    const raw = configApi.getOptionalString(
      'userManagement.internalDomainList',
    );
    return parseInternalDomains(raw);
  }, [configApi]);
  return useMemo(() => {
    const domain = extractDomain(email);
    return !!domain && internalDomains.includes(domain);
  }, [email, internalDomains]);
}
